"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _Logo = _interopRequireDefault(require("../../IconicDisplayElements/Logo"));

var _navPropType = _interopRequireDefault(require("../../../constants/navPropType"));

var _strings = _interopRequireDefault(require("../../../constants/strings"));

var _DropDownNav = _interopRequireDefault(require("../DropDownNav"));

var _MenuMobile = require("./MenuMobile.styles");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Menu/Header component.  Handles desktop and mobile renderings. Expects MenuItemsWrapper as children.
 *
 * The mobile menu does not support additional children content like the desktop version.
 */
var MenuMobile = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MenuMobile, _React$PureComponent);

  var _super = _createSuper(MenuMobile);

  function MenuMobile() {
    var _this;

    _classCallCheck(this, MenuMobile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menuOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "logoOnClickHandler", function () {
      return _this.props.logoOnClick();
    });

    _defineProperty(_assertThisInitialized(_this), "logInClickHandler", function () {
      return _this.props.logInHandler();
    });

    _defineProperty(_assertThisInitialized(_this), "logOutClickHandler", function () {
      return _this.props.logOutHandler();
    });

    _defineProperty(_assertThisInitialized(_this), "hamburgerClickHandler", function () {
      return _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuItemSelected", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    return _this;
  }

  _createClass(MenuMobile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeMenuIds = _this$props.activeMenuIds,
          children = _this$props.children,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          loggedIn = _this$props.loggedIn,
          logo = _this$props.logo,
          navConfig = _this$props.navConfig,
          showContactUsButton = _this$props.showContactUsButton,
          showLogInOutButtons = _this$props.showLogInOutButtons;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react.default.createElement(_MenuMobile.MobileMenuWrapper, {
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement(_MenuMobile.MobileMask, {
        isOpen: isOpen
      }), /*#__PURE__*/_react.default.createElement(_MenuMobile.StyledMenuMobile, {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
        dataTestId: "menu-mobile-logo",
        image: logo || null,
        mobile: true,
        onClick: this.logoOnClickHandler
      }), /*#__PURE__*/_react.default.createElement(_MenuMobile.ContentWrapper, null, children), /*#__PURE__*/_react.default.createElement(_MenuMobile.ControlsWrapper, null, /*#__PURE__*/_react.default.createElement(_MenuMobile.CloseControl, {
        isOpen: isOpen
      }, /*#__PURE__*/_react.default.createElement(_MenuMobile.ControlButton, {
        "data-test-id": "menu-desktop-close-button",
        onClick: this.hamburgerClickHandler
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        dataTestId: "c-menu-desktop-close-icon",
        iconName: "times"
      }), /*#__PURE__*/_react.default.createElement("span", null, _strings.default.close))), /*#__PURE__*/_react.default.createElement(_MenuMobile.HamburgerControl, {
        isOpen: isOpen
      }, /*#__PURE__*/_react.default.createElement(_MenuMobile.ControlButton, {
        "data-test-id": "menu-desktop-hamburger-button",
        onClick: this.hamburgerClickHandler
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        dataTestId: "c-menu-desktop-hamburger-icon",
        iconName: "bars"
      }), /*#__PURE__*/_react.default.createElement("span", null, _strings.default.menu))))), /*#__PURE__*/_react.default.createElement(_DropDownNav.default, {
        activeMenuIds: activeMenuIds,
        dataTestId: "mobile-menu-dropdown-nav",
        isOpen: isOpen,
        loggedIn: loggedIn,
        logInHandler: this.logInClickHandler,
        logOutHandler: this.logOutClickHandler,
        navConfig: navConfig,
        onMenuItemSelected: this.onMenuItemSelected,
        showContactUsButton: showContactUsButton,
        showLogInOutButtons: showLogInOutButtons
      }));
    }
  }]);

  return MenuMobile;
}(_react.default.PureComponent);

_defineProperty(MenuMobile, "propTypes", {
  /** Used to mark active menu items.
   * Position 0 is the top tier, and position 1 is the sub-nav.
   * The component copies initial props to internal state and runs on that after mount.
   * */
  activeMenuIds: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /** Children will only be displayed until we hit the medium breakpoint */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** flag for opening/closing the menu */
  isOpen: _propTypes.default.bool,

  /** logged in state flag for internal/external view */
  loggedIn: _propTypes.default.bool,

  /** log in event handler */
  logInHandler: _propTypes.default.func,

  /** alternate logo uri */
  logo: _propTypes.default.string,

  /** onClick function for the logo */
  logoOnClick: _propTypes.default.func,

  /** log out event handler */
  logOutHandler: _propTypes.default.func,

  /** navConfig to be displayed in side nav.
   * If you provide a subNav prop, it will trump the onclick if it is also provided.
   *  */
  navConfig: _navPropType.default.navConfig,

  /** phone number to use in the mobile header */
  phoneNo: _propTypes.default.string,

  /** flag for showing the contact us button - defaults to true */
  showContactUsButton: _propTypes.default.bool,

  /** flag for showing log in/out buttons - defaults to false */
  showLogInOutButtons: _propTypes.default.bool,

  /** flag only to be used by styleguide to turn off fixed positioning */
  _inStyleGuide: _propTypes.default.bool
});

_defineProperty(MenuMobile, "defaultProps", {
  activeMenuIds: [],
  children: undefined,
  className: '',
  isOpen: false,
  loggedIn: false,
  logInHandler: function logInHandler() {},
  logo: null,
  logoOnClick: function logoOnClick() {},
  logOutHandler: function logOutHandler() {},
  navConfig: undefined,
  phoneNo: '',
  _inStyleGuide: false
});

var _default = MenuMobile;
exports.default = _default;